module.exports = __webpack_public_path__ + "static/media/han-taste-ad4.7bf017f0.png";